import "./AboutUsStyles.css";

function AboutUs() {
  return (
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        Trippy has done a commendable job of personifying their team and
        organization while also narrating their story. The top of the page
        features a friendly image of the company's employees, and as you scroll,
        you will find their values, goals, journey, details about the founders,
        the team, and the culture. Along the way, webdew continues to share
        photos of its executives and all other team members, completely
        humanizing its brand by putting various faces to its name. The
        organization has also done a fabulous job of establishing trust by
        including elements of social proof (i.e., media, client testimonials,
        partner logos, etc.).{" "}
      </p>
      <h1>Our Mission</h1>
      <p>
        Trippy has done a commendable job of personifying their team and
        organization while also narrating their story. The top of the page
        features a friendly image of the company's employees, and as you scroll,
        you will find their values, goals, journey, details about the founders,
        the team, and the culture.
      </p>
      <h1>Our Vision</h1>
      <p>
        Trippy has done a commendable job of personifying their team and
        organization while also narrating their story. The top of the page
        features a friendly image of the company's employees, and as you scroll,
        you will find their values, goals, journey, details about the founders,
        the team, and the culture.
      </p>
    </div>
  );
}

export default AboutUs;
